var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusReject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.08 21.972h-8.4V1.812H8.4v5.04a1.685 1.685 0 001.68 1.68h5.04v2.52h1.68v-4.2a.765.765 0 00-.252-.588l-5.88-5.88a.763.763 0 00-.588-.252h-8.4A1.685 1.685 0 000 1.812v20.16a1.685 1.685 0 001.68 1.68h8.4v-1.68zm0-19.824l4.704 4.704H10.08V2.148z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.901 20.963l-2.112-2.112 2.112-2.112-1.056-1.056-2.112 2.112-2.112-2.112-1.056 1.056 2.112 2.112-2.111 2.112 1.055 1.056 2.112-2.112 2.112 2.112 1.056-1.056z",
    fill: "#ED1B2E"
  })));
}

export default SvgStatusReject;